// Plan limits for Family Bible subscription tiers.
// Family constraints (member count) live on the family doc via family.plan.
// Recording constraints (chapter count) are checked against the user's
// most permissive family plan at record time.

export const PLAN_LIMITS = {
  free:   { memberCount: 3,        chapterCount: 10 },
  legacy: { memberCount: 6,        chapterCount: Infinity },
  plus:   { memberCount: 15,       chapterCount: Infinity },
  beta:   { memberCount: Infinity, chapterCount: Infinity },
};

export const PLAN_LABELS = {
  free:   'Free Plan',
  legacy: 'Family Legacy',
  plus:   'Family+',
  beta:   'Friends Access',
};

export function getLimits(plan) {
  return PLAN_LIMITS[plan] || PLAN_LIMITS.free;
}

// Resolve the plan for a family document.
export function getFamilyPlan(family) {
  return family?.plan || 'free';
}

// Resolve the most permissive plan across a list of family objects.
// A user is allowed whatever their best family grants them.
export function getEffectivePlanFromFamilies(user, families = []) {
  if (user?.isBeta) return 'beta';
  const plans = families.map(f => f?.plan || 'free');
  if (plans.includes('beta'))   return 'beta';
  if (plans.includes('plus'))   return 'plus';
  if (plans.includes('legacy')) return 'legacy';
  return 'free';
}

// Resolve the plan for a single user (no family data available).
export function getUserPlan(user) {
  if (user?.isBeta) return 'beta';
  const plan = user?.subscriptionPlan;
  if (plan === 'plus' || plan === 'legacy') return plan;
  return 'free';
}

// Return the plan to stamp on a new family based on the creating user.
export function planForNewFamily(user) {
  return getUserPlan(user);
}
